const path = {
    adminPage: '/admin',
};

export default path;